/**************************
 * Interface CONFIGURATION
 **************************/

// Global configuration
const PAGINATION_DEFAULT_PAGESIZE = 20

// ..minimum Y-scrolling required (in pixels) before showing up the GoToTop icon
const SCROLL_MIN_Y_TO_SHOW_GOTOTOP = 150

// Configuration of modal-windows
const MODAL_WIDTH = '90%'
const MODAL_HEIGHT = '90%'

export default {
  PAGINATION_DEFAULT_PAGESIZE,
  SCROLL_MIN_Y_TO_SHOW_GOTOTOP,
  MODAL_WIDTH,
  MODAL_HEIGHT,
}
